// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"Departments_HeaderTitle__ufoAU","wrapperCards":"Departments_wrapperCards__FcCiA","card":"Departments_card__zyehY"};